import { useTranslation } from "react-i18next";

const DateRangeSheet = ({ isOpen, dateFrom, dateTo, onDateFromChange, onDateToChange, onClear, onApply }) => {
    const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/60"
        onClick={onApply}>
            <div className="absolute bottom-0 left-0 right-0 bg-background-800 rounded-t-2xl p-4"
                onClick={e => e.stopPropagation()}>
                <h3 className="text-white text-base mb-2">{t('general.date_range')}</h3>
                <p className="text-primary-50 text-xs mb-4">{t('reports.range_description')}</p>
                <div className="grid grid-cols-2 gap-2 mb-5 px-4 overflow-hidden">
                    <div className="min-w-0">
                        <label className="block text-xs text-primary-50 font-mono mb-1.5">{t('general.from')}</label>
                        <input type="date" value={dateFrom}
                        onChange={e => onDateFromChange(e.target.value)}
                        max={dateTo}
                        style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                        className="block bg-background-600 text-white border border-primary-50 rounded-xl px-2 py-2.5 text-sm
                        focus:outline-none focus:border-secondary-800"/>
                    </div>
                    <div className="min-w-0 pr-2">
                        <label className="block text-xs text-primary-50 font-mono mb-1.5">{t('general.to')}</label>
                        <input type="date" value={dateTo}
                        onChange={e => onDateToChange(e.target.value)}
                        min={dateFrom}
                        style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                        className="block bg-background-600 text-white border border-primary-50 rounded-xl px-2 py-2.5 text-sm
                        focus:outline-none focus:border-secondary-800"/>
                    </div>
                </div>
                <div className="flex gap-3 px-5">
                    <button onClick={onClear}
                            className="flex-1 bg-primary-800 text-primary-50 rounded-xl py-3 text-xs font-mono">
                            {t('general.clear')}
                    </button>
                    <button onClick={onApply}
                            className="flex-1 bg-secondary-800 text-white rounded-xl py-3 text-xs font-mono font-bold">
                            {t('general.apply_range')}
                    </button>
                </div>
            </div>
        </div>
        );            
};

export default DateRangeSheet;